import Connection, { ConnectionOptions } from './connection'

class Client {
  private readonly address: string
  private readonly options: ConnectionOptions

  constructor(address: string, options: ConnectionOptions = { keepalive: true }) {
    this.address = address
    this.options = options
  }

  createConnection(): Promise<Connection> {
    return new Connection(this.address, this.options).open()
  }
}

export default Client
